import { createGoogleProvider } from './google'
import { createFacebookProvider } from './facebook'
import { createAppleProvider } from './apple'
import type { SocialLoginProviderRegistry } from '@/types/socialLogin'

export const createSocialLoginProviders: SocialLoginProviderRegistry = () => ({
  google: createGoogleProvider(),
  facebook: createFacebookProvider(),
  apple: createAppleProvider(),
})
